/**
 * 유해위험기계기구 기본정보(HAZ_BASIC_01) 컬럼 정의
 * HAZ_BASIC_01 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import dayjs from 'dayjs';

/**
 * 유해위험기계기구 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 체크박스 컬럼 (NO 컬럼)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
    }),
    // 채번 컬럼 (숨김)
    CreateColumn('chaebun', '채번', 'left', 110, false, false, true, 'text', {
      minWidth: 110,
    }),
    // 최초/정기 컬럼
    CreateColumn(
      'initialRegular',
      '최초/정기',
      'center',
      120,
      true,
      false,
      false,
      'select',
      {
        selectOptions: ['최초', '정기'],
        minWidth: 120,
        flex: 1,
      }
    ),
    // 기계·기구·설비명 컬럼 (필수)
    CreateColumn(
      'machineName',
      '기계·기구·설비명',
      'left',
      200,
      true,
      true,
      false,
      'text',
      {
        minWidth: 200,
        flex: 1,
      }
    ),
    // 기계·기구·설비 이미지 컬럼 (fileButton)
    CreateColumn(
      'machineImageFileName',
      '기계·기구·설비 이미지',
      'center',
      200,
      false,
      false,
      false,
      'fileButton',
      {
        fileButtonClickHandler: (data, fieldName) => {
          props.PopupClickEvent1?.(data);
        },
        fileButtonFileNameKey: 'machineImageFileName',
        fileButtonFilePathKey: 'machineImageFilePath',
        minWidth: 200,
      }
    ),
    // 종류 컬럼
    CreateColumn('type', '종류', 'left', 80, true, false, false, 'text', {
      minWidth: 80,
      flex: 1,
    }),
    // 설치장소 컬럼
    CreateColumn(
      'installLocation',
      '설치장소',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 담당부서 컬럼
    CreateColumn(
      'department',
      '담당부서',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 담당자 컬럼
    CreateColumn(
      'personInCharge',
      '담당자',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 주요구조부 규격 컬럼
    CreateColumn(
      'mainStructureSpec',
      '주요구조부 규격 (형식/용량 등)',
      'left',
      240,
      true,
      false,
      false,
      'text',
      {
        minWidth: 240,
        flex: 1,
      }
    ),
    // 제조사 컬럼
    CreateColumn(
      'manufacturer',
      '제조사',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 제조번호 컬럼
    CreateColumn(
      'serialNo',
      '제조번호',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 최초 설치일자 컬럼 (date)
    CreateColumn(
      'initialInstallDate',
      '최초 설치일자',
      'center',
      160,
      true,
      false,
      false,
      'date',
      {
        minWidth: 160,
      }
    ),
    // 검사주기 컬럼 (편집불가)
    CreateColumn(
      'inspectionCycle',
      '검사주기 (3년/2년)',
      'center',
      180,
      false,
      false,
      false,
      'text',
      {
        tooltip: '최초/정기 선택 시 자동 입력됩니다.',
        cellClass: 'none-editable-cell',
        minWidth: 180,
        flex: 1,
        customCellStyle: {
          backgroundColor: '#f5f5f5',
          color: '#555',
          fontStyle: 'italic',
          cursor: 'not-allowed',
        },
      }
    ),
    // ALARM_ID 컬럼 (숨김)
    CreateColumn(
      'alarmId',
      'ALARM_ID',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        minWidth: 100,
      }
    ),
    // 합격통보일 컬럼 (date)
    CreateColumn(
      'inspectionDate',
      '합격통보일 (검사 승인 일정일)',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        headerComponentParams: {
          template:
            '<div class="ag-header-cell-label"><span>합격통보일<br>(검사 승인 일정일)</span></div>',
        },
        minWidth: 140,
      }
    ),
    // 유효기간 컬럼 (date)
    CreateColumn(
      'validityDate',
      '유효기간',
      'center',
      140,
      true,
      false,
      false,
      'date',
      {
        minWidth: 140,
      }
    ),
    // 합격번호 컬럼
    CreateColumn(
      'passNo',
      '합격번호',
      'left',
      140,
      true,
      false,
      false,
      'text',
      {
        minWidth: 140,
        flex: 1,
      }
    ),
    // 검사기관 컬럼
    CreateColumn(
      'inspectionAgency',
      '검사기관',
      'left',
      120,
      true,
      false,
      false,
      'text',
      {
        minWidth: 120,
        flex: 1,
      }
    ),
    // 검사원 컬럼
    CreateColumn(
      'inspector',
      '검사원',
      'left',
      100,
      true,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 알람여부 컬럼 (필수, select)
    CreateColumn(
      'alarmYn',
      '알람여부 (Y/N)',
      'center',
      130,
      true,
      true,
      false,
      'select',
      {
        selectOptions: ['Y', 'N'],
        width: 130,
      }
    ),
    // 알람일자 컬럼 (편집불가, valueGetter 사용)
    CreateColumn(
      'alarmDate',
      '알람일자',
      'center',
      130,
      false,
      false,
      false,
      'date',
      {
        tooltip: (params) => {
          const alarmYn = params.data?.alarmYn;
          if (alarmYn !== 'Y') {
            return "알림여부가 'Y'일 때만 알람일자가 설정됩니다.";
          }
          return '알림은 유효기간 두 달 전에 발송됩니다.';
        },
        cellClass: 'none-editable-cell',
        width: 130,
        customCellStyle: {
          backgroundColor: '#f5f5f5',
          color: '#555',
          fontStyle: 'italic',
          cursor: 'not-allowed',
        },
        valueGetter: (params) => {
          const alarmYn = params.data?.alarmYn;
          const validity = params.data?.validityDate;

          if (alarmYn !== 'Y') return null;
          if (!validity) return null;

          const date = new Date(validity);
          if (isNaN(date.getTime())) return null;

          date.setMonth(date.getMonth() - 2);
          return date.toISOString();
        },
        valueFormatter: (params) => {
          if (!params.value) return '';
          return dayjs(params.value).format('YYYY-MM-DD');
        },
      }
    ),
    // 비고 컬럼
    CreateColumn('remark', '비고', 'left', 120, true, false, false, 'text', {
      minWidth: 120,
      flex: 1,
    }),
    // 기계·기구·설비 이미지 저장명 컬럼 (숨김)
    CreateColumn(
      'machineImageSaveName',
      '기계·기구·설비 이미지 저장명',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 기계·기구·설비 이미지 파일 경로 컬럼 (숨김)
    CreateColumn(
      'machineImageFilePath',
      '기계·기구·설비 이미지 파일 주소',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
    // 미리보기 파일 경로 컬럼 (숨김)
    CreateColumn(
      'previewFilePath',
      '미리보기 파일 경로',
      'left',
      200,
      false,
      false,
      true,
      'text',
      {
        flex: 1,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
